var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMediaSave = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "none",
  viewBox: "0 0 15 15",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.042 13.875V8.208H3.958v5.667m0-12.75v3.542h5.667m2.833 9.208H2.542a1.417 1.417 0 0 1-1.417-1.417V2.542a1.417 1.417 0 0 1 1.417-1.417h7.791l3.542 3.542v7.791a1.417 1.417 0 0 1-1.417 1.417"
})));
export { SvgMediaSave as ReactComponent };
export default __webpack_public_path__ + "assets/images/media-save.svg";